// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"834":"17599ec101f375a2","885":"b780d5b123a6c17c"}[chunkId] + ".css";
};